import styled, { StyledProps } from 'styled-components/macro';

export type AccordionStyleProps = StyledProps<{
  isOpen?: boolean;
}>;

export const AccordionTitle = styled.div`
  color: ${(props) => props.theme.colors.dark};
  font-size: 13px;
  cursor: pointer;
`;

export const AccordionArrow = styled.div`
  cursor: pointer;
  transition: 0.3s;
`;

export const AccordionContent = styled.div`
  display: flex;
`;

export const AccordionHeader = styled.div<{ height?: 'string' }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 53px;
`;

export const Accordion = styled.div<AccordionStyleProps>`
  padding: 0 15px;
  ${AccordionContent} {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  }
`;
